import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, getDoc, limit, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../firebaseConfig.js"; // Importa tu instancia de Firebase
import "./Search.css";

const Search = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (searchTerm.trim() === "") {
        setResults([]);
        return;
      }
    
      setLoading(true);
      const lowerCaseTerm = searchTerm.toLowerCase();
      const allResults = [];
    
      try {
        // Buscar profesionales con role = "servicios"
        const professionalsQuery = query(
          collection(db, "users"),
          where("role", "==", "servicios"),
          limit(20)
        );
        const professionalsSnapshot = await getDocs(professionalsQuery);
    
        const filteredResults = professionalsSnapshot.docs.filter((doc) => {
          const data = doc.data();
          return (
            data.profession &&
            data.profession.toLowerCase().includes(lowerCaseTerm)
          );
        });
    
        filteredResults.forEach((doc) => {
          const data = doc.data();
          allResults.push({
            id: doc.id,
            type: "professional",
            fullName: data.fullName || "Sin nombre",
            profession: data.profession || "Sin Profesion",
            rating: data.rating || "Sin valoraciones",
          });
        });
    
        // Buscar empresas
        const companiesQuery = query(collection(db, "empresas"));
        const companiesSnapshot = await getDocs(companiesQuery);
    
        companiesSnapshot.forEach((doc) => {
          const data = doc.data();
          const companyName = data.companyName || "";
          const industry = data.industry || "";
    
          if (
            companyName.toLowerCase().includes(lowerCaseTerm) ||
            industry.toLowerCase().includes(lowerCaseTerm)
          ) {
            allResults.push({
              id: doc.id,
              type: "company",
              companyName,
              industry,
            });
          }
        });
    
        // Buscar postulantes
        const applicantsQuery = query(collection(db, "postulantes"));
        const applicantsSnapshot = await getDocs(applicantsQuery);
    
        for (const docSnap of applicantsSnapshot.docs) {
          const data = docSnap.data();
          const skills = Array.isArray(data.skills) 
            ? data.skills.map(skill => skill.toLowerCase()) 
            : [];
        
          if (skills.some((skill) => skill.includes(lowerCaseTerm))) {
            const userRef = doc(db, "users", data.uid);
            const userDoc = await getDoc(userRef);
        
            if (userDoc.exists()) {
              const userData = userDoc.data();
              allResults.push({
                id: docSnap.id,
                type: "applicant",
                fullName: userData.fullName || "Sin nombre",
                skills: data.skills ? data.skills.join(", ") : "Sin habilidades",
              });
            } else {
              console.warn(`Usuario con UID ${data.uid} no existe en "users".`);
            }
          }
        }
        
    
        // Filtrar duplicados
        const uniqueResults = Array.from(
          new Map(allResults.map((item) => [`${item.type}-${item.id}`, item])).values()
        );
    
        if (uniqueResults.length === 0) {
          setResults([{ message: "No hay coincidencias." }]);
        } else {
          setResults(uniqueResults.slice(0, 20));
        }
      } catch (error) {
        console.error("Error al buscar datos:", error);
      } finally {
        setLoading(false);
      }
    };
    
    const delayDebounce = setTimeout(() => {
      fetchData();
    }, 500); // Espera 500ms después de que el usuario deje de escribir

    return () => clearTimeout(delayDebounce); // Cancelar si el usuario escribe antes de 500ms
  }, [searchTerm]);

  const handleNavigate = (item) => {
    if (item.type === "professional") {
      navigate(`/personal-card/${item.id}`);
    } else if (item.type === "company") {
      navigate(`/company-profile/${item.id}`);
    } else if (item.type === "applicant") {
      navigate(`/curriculum/${item.id}`);
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        className="form-control"
        placeholder="Busca profesionales, empresas o postulantes..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {loading && <p className="loading">Cargando resultados...</p>}
      <ul className="search-results">
        {results.length > 0 &&
          results.map((item) =>
            item.message ? (
              <li key={`message-${item.message}`} className="no-results">
                {item.message}
              </li>
            ) : (
              <li
                key={`${item.type}-${item.id}`} // Clave única combinando type e id
                className="search-result-item"
                onClick={() => handleNavigate(item)}
              >
              <div className="result-name">{item.fullName || item.companyName}</div>
                {item.type === "professional" && (
                  <>
                    <div className="result-rating">{item.rating}</div>
                    <div className="result-profession">{item.profession}</div>
                  </>
                )}
                {item.type === "company" && (
                  <div className="result-industry">{item.industry}</div>
                )}
                {item.type === "applicant" && (
                  <div className="result-skills">{item.skills}</div>
                )}
              </li>
            )
          )}
      </ul>
    </div>
  );
};

export default Search;
